export const MOBILE_APP_FORCE_EXCLUDE = {
  ADDED: 'Manager Email added successfully.',
  UPDATED: 'Manager Email updated successfully.',
  DELETED: 'Manager Email deleted successfully.',
  ITEM_EXISTS: 'Manager Email already added in the list.',
  MANAGER_NOT_FOUND:
    'Manager not found, please make sure to enter a manager email.',
} as const;

export const APPS_INTEGRATIONS = {
  INVALID_APP_OR_STATUS: 'Invalid integration app or status, please try again.',
} as const;
